import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

// Public overlay page for vMix/OBS Browser Source.
// Redirects to the static transparent HTML so nothing from the React app
// (body backgrounds, wrappers) can leak an opaque background into the capture.
export default function OverlayPage() {
  const { matchId } = useParams();
  useEffect(() => {
    window.location.replace(`/overlay-view.html?matchId=${encodeURIComponent(matchId)}`);
  }, [matchId]);
  return null;
}
